// extracted by mini-css-extract-plugin
export var arrow = "_ig-1";
export var content = "_ig-0";
export var highlighted = "_ig-2";